import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@serota/ui-web/styles.css';
import { installBrowserErrorReporting } from '@serota/api-client';
import { configureMaps } from '@serota/ui-web/map-config';
import { API_URL } from './lib/config';
import { App } from './App';

installBrowserErrorReporting(API_URL, 'admin');
// Google Maps anahtarı varsa tüm haritalar Google Maps JavaScript API ile; yoksa MapLibre (kök .env: VITE_GOOGLE_MAPS_KEY)
configureMaps({ googleApiKey: (import.meta.env.VITE_GOOGLE_MAPS_KEY as string | undefined) || null });

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
